<nav role="none" id="pcgMainNavigation" class="navbar navbar-expand-lg top-nav-bg">
  <div id="primaryNav" class="align-items-center w-100">
    <button
      aria-label="Open menu"
      [attr.aria-expanded]="this.currMainNavMenu !== ''"
      aria-controls="pcgTopClickNavEl"
      #mainHamburger
      [class.d-none]="!navRoutes || navRoutes.length === 0"
      (click)="toggleNav()"
      id="mainHamburger"
      class="float-right btn btn-sm mt-2"
      >
      <svg viewBox="0 0 30 30" xmlns="http://www.w3.org/2000/svg">
        <path stroke-width="2" stroke-linecap="round" stroke-miterlimit="10" d="M4 7h22M4 15h22M4 23h22"></path>
      </svg>
    </button>
    <div role="banner" class="navbar-header">
      <a tabindex="-1" [class.dev]="mode === 'Development'" [class.test]="mode === 'Demo'" class="navbar-brand" [routerLink]="['/']">
        <img alt="" src="assets/images/logos/logo_small.png" height="35px" />
        Target Print &amp; Mail
      </a>
    </div>
    <pcg-top-click-nav
      id="pcgTopClickNavEl"
      [class.d-none]="!navRoutes?.length"
      [navRoutes]="navRoutes"
    ></pcg-top-click-nav>
    <div id="rightNavContainer" class="ml-auto align-items-center">
      @if (user) {
        <ul #userNav id="userNav" class="nav navbar-nav top-nav-bg">
          <li
            id="userNavDropDown_collapser"
            class="dropdown"
            [class.bottom-arrow]="currSelectedNavMenu?.parentNav?.isInUserNav"
            >
            <a
              role="button"
              [attr.aria-expanded]="userNavOpen"
              aria-controls="userNavDropDown"
              href="#"
              (click)="checkAccess(); userNavOpen = !userNavOpen; (false)"
              class="d-block dropdown-toggle"
              >
              {{ user.firstName }} {{ user.lastName }}
            </a>
            <ul
              aria-labelledby="userNavDropDown_collapser"
              id="userNavDropDown"
              class="dropdown-menu top-nav-bg"
              [class.nav-open]="userNavOpen"
              >
              <li [routerLinkActive]="['link-active']" [routerLinkActiveOptions]="{ exact: true }">
                <a (click)="clickUserLink()" class="d-block" [routerLink]="'/edit-user/' + user.id">
                  My Profile
                </a>
              </li>
              <li [routerLinkActive]="['link-active']">
                <a (click)="clickUserLink()" class="d-block" routerLink="/help"> Help </a>
              </li>
              <li>
                <a class="d-block" href="#" (click)="logout(); clickUserLink(); (false)"> Logout </a>
              </li>
            </ul>
          </li>
        </ul>
      }
      @if (user) {
        <a
          id="btnSearch"
          role="button"
          aria-label="Open the global navigation search modal. This can also be opened by hitting the '/' key"
          #btnSearch
          (click)="openSearch()"
          class="pr-2 ml-3"
          container="body"
          placement="left"
          ngbTooltip='Click to open the global navigation search. This can also be opened by hitting the "/" key.'
          >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 490 490">
            <path
              fill="#000"
              stroke="#ccc"
              stroke-width="36"
              stroke-linecap="round"
              d="m280,278a153,153 0 1,0-2,2l170,170m-91-117 110,110-26,26-110-110"
              />
            </svg>
          </a>
        }
      </div>
    </div>
    @if (currSelectedNavMenu && currSelectedNavMenu.id !== 'root') {
      <div id="secondaryNav">
        <div class="container">
          <span class="current-section">{{ currSelectedNavMenu.name }}</span>
          <pcg-top-secondary-nav
            role="navigation"
            aria-label="Secondary"
            [forceSelect]="currForceSelect"
            [rootNavId]="'root' + navDividerCharacter + currSelectedNavMenu.id.split(navDividerCharacter)[1]"
            [routeNavId]="currSelectedNavMenu.id"
            [navRoutes]="currSelectedNavMenu.children"
          ></pcg-top-secondary-nav>
        </div>
      </div>
    }
  </nav>
